import { theme } from 'styles/theme';

export { theme };
